import { toast } from "react-toastify";

export const useToast = () => {
  const showInfoToast = (message: string) => {
    toast.error(message);
  };

  const showSuccessToast = (message: string) => {
    toast.success(message);
  };

  const showErrorToast = (message: string) => {
    toast.error(message);
  };

  return { showInfoToast, showSuccessToast, showErrorToast };
};

